import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import FormField from '../FormField';
import Conditional from '@app/components/common/Conditional';

const NameField = ({ showName }) => {
  const [t] = useTranslation();

  return (
    <Conditional test={showName}>
      <FormField
        fieldId="firstName"
        required
        label={t('CAT_EMAIL_FIRSTNAME')}
        maxLength="20"
      />
      <FormField
        fieldId="lastName"
        required
        label={t('CAT_EMAIL_LASTNAME')}
        maxLength="20"
      />
    </Conditional>
  );
};

NameField.propTypes = {
  showName: PropTypes.bool
};

export default NameField;
